module.exports = __webpack_public_path__ + "7d761adb43e3afe67966b9520ac711bc.png";